import React from 'react';

import { Icon } from 'js/design_system/Icon';

import { IconAnchor, IconContainer, IconLabel } from './styles';
import { uploadUrl } from 'js/header/FocusedNav/uploadUrl';
import styled from 'astroturf/react';
import _NotificationDot from "UploadButton-NotificationDot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/CoreXNav/nav_buttons/UploadButton.tsx?styleId=NotificationDot";


export const NotificationDot = /*#__PURE__*/styled("div", null, {
  displayName: "NotificationDot",
  styles: _NotificationDot
});

type Props = {
  hasUnseenClaimablePapers: boolean;
  hasUnseenUploadableStubs: boolean;
  onClick?: () => void;
};

const UploadButton = ({
  hasUnseenClaimablePapers,
  hasUnseenUploadableStubs,
  onClick,
}: Props) => {
  const url = uploadUrl({
    hasUnseenUploadableStubs,
    hasUnseenClaimablePapers,
    trigger: 'nav',
  });

  return (
    <>
      <IconAnchor key="upload" href={url} onClick={onClick}>
        <IconContainer>
          <Icon name="upload" size={25} />
        </IconContainer>
        <IconLabel>Upload</IconLabel>
      </IconAnchor>
      {(hasUnseenClaimablePapers || hasUnseenUploadableStubs) && (
        <NotificationDot />
      )}
    </>
  );
};

export default UploadButton;
